import React from "react";
import ModuleNavigation from "../ModuleNavigation";

export default function ShipmentsModule() {
  return <ModuleNavigation moduleId="ShipmentsModule" />;
}
